// Side Quest Supplies cart upsell: handles the "Add" buttons rendered by
// snippets/side-quest-upsell.liquid in the cart drawer and on the cart page.
// Loaded with the page (not inside the drawer markup) because scripts in
// re-rendered drawer HTML never run.
(function () {
  if (window.__sqUpsellBound) return;
  window.__sqUpsellBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sq-variant]');
    if (!button) return;
    event.preventDefault();
    var drawer = button.closest('cart-drawer');
    button.setAttribute('aria-busy', 'true');
    var body = { items: [{ id: Number(button.dataset.sqVariant), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { button.removeAttribute('aria-busy'); return; }
        if (drawer && drawer.renderContents && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { button.removeAttribute('aria-busy'); });
  });
})();
